import { render, staticRenderFns } from "./SimilarText.vue?vue&type=template&id=3448c7ae&scoped=true&"
import script from "./SimilarText.vue?vue&type=script&lang=js&"
export * from "./SimilarText.vue?vue&type=script&lang=js&"
import style0 from "./SimilarText.vue?vue&type=style&index=0&id=3448c7ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3448c7ae",
  null
  
)

export default component.exports